import { type FC } from 'react';
import { Stack } from '@mantine/core';
import { createOrder, type CreateOrderPaymentMethod } from './actions';
import { Actions, OrdersList } from './components';
import { paginationModel, filters } from './model';

export const Processing: FC = () => {
    const handleCreate = (paymentMethod: CreateOrderPaymentMethod) => {
        createOrder({
            paymentMethod,
        });
    };

    return (
        <Stack gap='md'>
            <Actions onCreate={handleCreate} />

            <OrdersList
                filters={filters}
                paginationModel={paginationModel}
            />
        </Stack>
    );
};
